import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useBrowsePrimitivesPageQueryOptions } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.primitives.query";
import { useCallback } from "react";

/** Primitives → Compounds view: each primitive with its example characters. */
function useNavigator() {
  const browsePrimitivesPageQueryOptions = useBrowsePrimitivesPageQueryOptions();

  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/browse/(browse-tabs)/primitives/compounds",
      },
      queries: [browsePrimitivesPageQueryOptions],
    }),
    [browsePrimitivesPageQueryOptions],
  );
}

export const useBrowsePrimitivesCompoundsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
